import React from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';
import TagsColumn from '../../../components/columns/tags-column';
import { messages } from './messages';

const TagsColumnWrapper = ({ customerId, expanded = false, isFirstRow = false }) => {
  const [customer] = useSelector((state) => Global.selectEntitiesCustomersByIds(state, { customerIds: [customerId] })) ?? [];

  if (!customer || !customer.tagIds || (expanded && !isFirstRow)) {
    return '';
  }
  const tagIds = customer.tagIds || emptyArray;

  return <TagsColumn tagIds={tagIds} />;
};

export const Tags = {
  getMessageDescriptor: () => messages.tags,
  id: 'tags',

  render: ({ customerId }, { isExpanded = false, isFirstRow = false } = {}) => {
    return <TagsColumnWrapper customerId={customerId} expanded={isExpanded} isFirstRow={isFirstRow} />;
  },
};
